import './social_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.ImageContent extends Monitoring.Models.SocialContents.SocialContent

  initialize: (json) ->
    super(json)

  image: ->
    #TODO: get the image from the image content JSON when it gets defined
    'https://vignette2.wikia.nocookie.net/asdfmovie/images/5/5d/Shirt_asdf_suicidalmuffin.jpg/revision/latest?cb=20131029105355'


  #TODO: Check the types when the image content gets defined (groupType, type, subType)
  groupType: ->
    'image'

  type: ->
    'image'

  subType: ->
    'image'

  getClass: ->
    'Image Content view'
